

//     $('.slider_').slick({
//   dots: false,
//   speed: 300,
//   slidesToShow: ,
//   slidesToScroll: 1,
//   autoplay: false,
//   infinite: true,
//   cssEase:'linear',
//   prevArrow:'<button class="slick-arrow slick-prev"><svg width="37" height="37" viewBox="0 0 37 37" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="18.4783" cy="18.4783" r="18.4783" transform="matrix(-1 0 0 1 36.957 0)" fill="#DD8A9C"/><path d="M20.7881 13.579L20.0908 12.9348L14.3207 18.2473L20.0908 23.5599L20.7881 22.919L15.7186 18.2473L20.7881 13.579Z" fill="white"/></svg></button>',
//   nextArrow:'<button class="slick-arrow slick-next"><svg width="38" height="37" viewBox="0 0 38 37" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="19.4354" cy="18.4783" r="18.4783" fill="#DD8A9C"/><path d="M17.125 13.579L17.8223 12.9348L23.5924 18.2473L17.8223 23.5599L17.125 22.919L22.1945 18.2473L17.125 13.579Z" fill="white"/></svg></button>',
 
//   responsive: [
//     {
//       breakpoint: 768,
//       settings: {
//         slidesToShow: , 
//         slidesToScroll: 1, 
//       }
//     }
//   ]
// });



 $(".trigger_video_play_js").click(function () {
    var e = jQuery(this).parents(".video_wrapper_custom").find("video");
    $(this).hasClass("active") ? (jQuery(this).removeClass("active"), e.trigger("pause")) : (e.trigger("play"), jQuery(this).addClass("active"));
}),
    $(".read_more").click(function () {
        jQuery(this).parents(".rte").find("p").slideDown(), jQuery(this).parents(".rte").addClass("active");
    }),
    $(".read_less").click(function () {
        jQuery(this).parents(".rte").find("p").slideUp(), jQuery(this).parents(".rte").removeClass("active");
    }),
    $('.popup_ingredients p a[href="#"]').click(function (e) {
        e.preventDefault(), jQuery(this).parents(".popup_ingredients").find(".custom_popup").show();
    }),
    $(".custom_popup_bg").click(function (e) {
        e.preventDefault(), jQuery(".custom_popup").hide();
    }); 



    $('.custom-slide').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    dots: false,
    arrows: true,  
    loop: true,
    adaptiveHeight: true,
    autoplay: true,
    autoplaySpeed: 5000,
//     speed: 7000,
    cssEase: "linear",
    infinite: true,
    pauseOnHover: false,
      responsive: [
         {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true,
            dots: false,
          }
        }
      ]
  });
